import SocketGuruService from 'ember-socket-guru/services/socket-guru';
import ENV from 'bullitt-time-gochips/config/environment';

export default class SocketGuru extends SocketGuruService {
	constructor() {
		super({
			socketClient: 'socketio',
			config: {
				host: `${ENV.gochipsBackendProtocol}://${ENV.gochipsBackendHost}:${ENV.gochipsBackendPort}`,
				namespace: ENV.gochipsBackendNamespace ? "/"+ENV.gochipsBackendNamespace : ""
			},
			observedChannels: ['stdOut', 'stdErr']
		});
	}
}